(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('panelController', panelController);

    panelController.$inject = ['$http','$sce','userSession','messageService','CONFIG'];

    function panelController($http, $sce, userSession, messageService,CONFIG) {
        var vm = this;
        var urlOriginal = CONFIG.API_URL + "/kie-service/public/file-commercial-panel/" + userSession.data.userId;
        $http.get(urlOriginal)
            .then(function(response) {
                vm.urlReport = $sce.trustAsResourceUrl(urlOriginal);
            })
            .catch(function(error) {
                messageService.withoutPermissionPanel();
            });
    }
})();
